export default class BlockFullWidthImageCarousel {
    constructor(container, options) {
        const defaultOptions = {
            carousel: '.swiper',
            pagination: '.swiper-pagination',
            paginationPrevious: '.swiper-button-prev',
            paginationNext: '.swiper-button-next',
        };
        this.options = Object.assign({}, defaultOptions, options);

        this.container = document.querySelector(container);

        this.carousel = this.container.querySelector(this.options.carousel);
        this.pagination = this.container.querySelector(this.options.pagination);
        this.paginationPrevious = this.container.querySelector(this.options.paginationPrevious);
        this.paginationNext = this.container.querySelector(this.options.paginationNext);
        
        if(this.carousel.querySelectorAll('.swiper-slide').length > 1)
            this.initSwiper();
    }
    
    initSwiper() {
        const swiperOptions = {
            direction: 'horizontal',
            loop: true,
            grabCursor: true,
            slidesPerView: 1.15,
            spaceBetween: 15,
            centeredSlides: true,
            autoplay:{
                delay: 3000
            },
            initialSlide: 0,

            pagination: {
                el: this.pagination,
                clickable: true
            },
            navigation: {
                nextEl: this.paginationNext,
                prevEl: this.paginationPrevious,
            },
            breakpoints: {
                768: {
                    slidesPerView: 1,                  
                }
            }
        };
     
        new Swiper(this.carousel, swiperOptions);
    }
}